module.exports = __webpack_public_path__ + "static/img/yytx40.32c95ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx40.png
// module id = 907
// module chunks = 0